export default {"src":"/_next/static/media/loginLock.083f6ac1.svg","height":22,"width":20,"blurWidth":0,"blurHeight":0};